import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useVoucherTypeReducer = () => useSelector((state: ApplicationState) => state.voucherType);
